const cityButtons = document.querySelectorAll(
  ".territory-maps__countries--button"
);
const svgMaps = document.querySelectorAll(".territory-svg");
const programsContainer = document.querySelector(".territory-svg__programs");
const closeProgramsBtn = document.querySelector(
  ".territory-svg__programs--button"
);
const resultsContainer = document.getElementById("programs-results");

const cityIds = Array.from(cityButtons).map((btn) => btn.dataset.municipality);

async function activateAndFilter(municipalityId, departmentId, qty) {
  document
    .querySelectorAll(".selectable")
    .forEach((el) => el.classList.remove("active"));
  cityButtons.forEach((btn) => btn.classList.remove("active"));

  const correspondingBtn = document.querySelector(
    `.territory-maps__countries--button[data-municipality="${municipalityId}"]`
  );
  if (correspondingBtn) correspondingBtn.classList.add("active");

  svgMaps.forEach((svg) => {
    const path = svg.querySelector(`path#${municipalityId}`);
    if (path) path.classList.add("active");
  });

  const programs = await filterPrograms(municipalityId, departmentId);
  displayPrograms(programs, municipalityId, qty);
}

async function filterPrograms(municipalityId, departmentId) {
  try {
    programsContainer.classList.add("loading");
    const response = await fetch(tdea_ajax.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "territory_filter_programs",
        nonce: tdea_ajax.nonce,
        municipality_id: municipalityId,
        department_id: departmentId,
        map_programs: true,
      }),
    });
    const data = await response.json();
    return data.data.programs || [];
  } catch (error) {
    console.error("Error:", error);
    return [];
  } finally {
    programsContainer.classList.remove("loading");
  }
}

function displayPrograms(programs, city, qty) {
  if (programs.length > 0) {
    resultsContainer.innerHTML = programs
      .map(
        (program) => `
      <article class="faculties__card">
        <div class="faculties__card-content">
          <div class="faculties__icon">
            <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 21L17 11M17 11H7M17 11V21" stroke="#92BD24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h3 class="faculties__card-title h3">
            <a href="${program.permalink}" class="faculties__card-link">${program.title}</a>
          </h3>
          <div class="faculties__card-button-wrapper">
            <a href="${program.permalink}" class="faculties__card-button button button-1 button-lg">
              Más información
              <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 21L17 11M17 11H7M17 11V21" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </article>
    `
      )
      .join("");

    document.querySelector(".territory-svg__programs--span").textContent = city;
    document.querySelector(".territory-svg__programs--qty-span").textContent =
      qty;
    programsContainer.classList.add("isOpen");
  } else {
    resultsContainer.innerHTML =
      "<p class='no-programs'>No hay programas disponibles en esta ciudad.</p>";
    document.querySelector(".territory-svg__programs--qty-span").textContent =
      "0";
    programsContainer.classList.add("isOpen");
  }
}

cityButtons.forEach((button) => {
  button.addEventListener("click", function () {
    activateAndFilter(
      this.dataset.municipality,
      this.dataset.department,
      this.dataset.qty
    );
  });
});

svgMaps.forEach((svg) => {
  const paths = svg.querySelectorAll("path");
  paths.forEach((path) => {
    if (cityIds.includes(path.id)) {
      path.classList.add("selectable");
      path.addEventListener("click", async function () {
        const correspondingBtn = document.querySelector(
          `.territory-maps__countries--button[data-municipality="${this.id}"]`
        );
        if (correspondingBtn) {
          await activateAndFilter(
            this.id,
            correspondingBtn.dataset.department,
            correspondingBtn.dataset.qty
          );
        }
      });
    }
  });
});

closeProgramsBtn.addEventListener("click", function () {
  programsContainer.classList.remove("isOpen");
  document
    .querySelectorAll(".selectable")
    .forEach((el) => el.classList.remove("active"));
  cityButtons.forEach((btn) => btn.classList.remove("active"));
});
